import { Injectable } from '@angular/core';
import {AppConfigService} from './app-config.service';
@Injectable()
export class Configuration {
    // public server = 'http://35.200.230.132:8081/'; //'http://192.168.0.253:82/';//'http://localhost:5000/';
    // public apiUrl = 'api';
    // public serverWithApiUrl = this.server + this.apiUrl;
    // public CreatedLoginID =1;
    // public UpdatedLoginID =1;
    // public StudentID =0;
    // public StuPoartlaID =1;
    // public PhotoPath='';
    // public SignPath='';
    // public Password=""
    public server = ''; 
    public apiUrl = '';
    public serverWithApiUrl = this.server + this.apiUrl;
    public CreatedLoginID =1;
    public UpdatedLoginID =1;
    public StudentID =0;
    public StuPoartlaID =1;
    public PhotoPath='';
    public SignPath='';
    public Password=""
    public portalopen="";
	public LogoPath='';
	public ImageSize=0;
	public SignSize=0;
    public FileUploadSize=0;
    public PaymentAPIURL="";
    public AcademicInstanceID=0;
    public RegistrationConfirm=false;
    public StudentProfileLock='';
    public OTPTimeLimt=0;
    public ExamInstanceID=0;
    public UniversityFlag='';
    public SysUsrGrpID="";  
    public LoginPageText  ="";
    public PRNNo="";
    public LanguageLabel=[];
    public SelectedLanguage="";
    public PurposeCodeCET=101;
    public PurposeCodeAdmission=102;
    public PurposeCodeEnrolment=103;
    public PurposeCodeHostel=104;
    public PurposeCodeExam=105;
    public PurposeCodeRequest=106;
    public PurposeCodeResultQuery=107;
    public PurposeCodeConvocation=108;
    public PurposeCodeProspect=109;
    public SmsEmailSendOTPFlag ="N";
    public CollegeID = 0;
    public Collegenm="";
    public progoramlist=[];
    public FromProspect=false;
    public ApplicationTitle="";
    public ApplicationTitleInDevngari="";
    public Logo1='';
    public Logo2='';
    public ProfileLockStatusFlag="";
    public ProspectFlag="";
    public ProspectPurchaseFlag="";
    public prospectshow=0;
    public loginpageshow="";
    public pdflink="";
    public loggedstatus="N";
    public SupportContact="";
    public ShowMeritList="N";
    public marqueeText="";
    public MeritLinkName="";
    public MeritArray=[];
    public UploadFile:any;
    public EnrolmentFile:any;
    public EnrolmentFile2:any;
    public EnrolmentFile3:any;
    public ExternalFlag:"N";    
    public IsParrent:boolean=false;
    public WeeklyOff:string="Sunday";
    public SubjectShowFlag:string;
    public ContactDetails:string="";
    public Instructionvideo:string="";
    public videoshow:boolean=false;
    public SubjectTotalCredits: string ="";
    constructor(private appConfigService: AppConfigService) {
        this.server=this.appConfigService.server;
        this.apiUrl=this.appConfigService.apiUrl;
        this.serverWithApiUrl=this.appConfigService.serverWithApiUrl;
        this.CreatedLoginID=this.appConfigService.CreatedLoginID;
        this.UpdatedLoginID=this.appConfigService.UpdatedLoginID;
        this.StudentID=this.appConfigService.StudentID;
        this.StuPoartlaID=this.appConfigService.StuPoartlaID;
        this.PhotoPath=this.appConfigService.PhotoPath;
        this.SignPath=this.appConfigService.SignPath;
        this.Password=this.appConfigService.Password;
        this.portalopen=this.appConfigService.portalopen;
		this.LogoPath=this.appConfigService.LogoPath;
		this.ImageSize=this.appConfigService.ImageSize;
		this.SignSize=this.appConfigService.SignSize;
        this.FileUploadSize=this.appConfigService.FileUploadSize;
        this.PaymentAPIURL=this.appConfigService.PaymentAPIURL;
        this.AcademicInstanceID= this.appConfigService.AcademicInstanceID;
        this.ExamInstanceID= this.appConfigService.ExamInstanceID;
        this.RegistrationConfirm=false;
        this.StudentProfileLock='';
        this.SysUsrGrpID=this.appConfigService.SysUsrGrpID;
        this.OTPTimeLimt= this.appConfigService.OTPTimeLimt;//300000;
        this.LoginPageText =this.appConfigService.LoginPageText;
        this.PRNNo=this.appConfigService.PRNNo;
        this.LanguageLabel=[];
        this.SmsEmailSendOTPFlag=this.appConfigService.SmsEmailSendOTPFlag;
        this.CollegeID = this.appConfigService.CollegeID;
        this.Collegenm = this.appConfigService.Collegenm;
        this.progoramlist = this.appConfigService.progoramlist;
        this.FromProspect=this.appConfigService.FromProspect;
        this.ApplicationTitle =this.appConfigService.ApplicationTitle;
        this.ApplicationTitleInDevngari =this.appConfigService.ApplicationTitleInDevngari;
        this.Logo1=this.appConfigService.Logo1;
        this.Logo2=this.appConfigService.Logo2;
        this.ProfileLockStatusFlag=this.appConfigService.ProfileLockStatusFlag;
        this.ProspectFlag=this.appConfigService.ProspectFlag;
        this.ProspectPurchaseFlag=this.appConfigService.ProspectPurchaseFlag;
        this.prospectshow=this.appConfigService.prospectshow;
        this.loginpageshow=this.appConfigService.loginpageshow;
        this.pdflink =this.appConfigService.pdflink;
        this.loggedstatus =this.appConfigService.loggedstatus;
        this.SupportContact =this.appConfigService.SupportContact;
        this.ShowMeritList =this.appConfigService.ShowMeritList;
        this.marqueeText =this.appConfigService.marqueeText;
        this.MeritLinkName =this.appConfigService.MeritLinkName;
        this.MeritArray =this.appConfigService.MeritArray;
        this.ExternalFlag=this.appConfigService.ExternalFlag;
        this.IsParrent=this.appConfigService.IsParrent;
        this.WeeklyOff=this.appConfigService.WeeklyOff;
        this.SubjectShowFlag=this.appConfigService.SubjectShowFlag;
        this.ContactDetails=this.appConfigService.ContactDetail;
        this.Instructionvideo=this.appConfigService.Instructionvideo;
        this.videoshow=this.appConfigService.videoshow;
        
     }

    

}
export class BaseClass{
    public CreatedDate :string;
    public CreatedLoginID : number;
    public UpdatedDate :string;
    public UpdatedLoginID : number;
    public DeleteFlag:string;
    
}